(function () {
  function formatMoney(cents, currency) {
    var amount = Number(cents || 0) / 100;
    try {
      return new Intl.NumberFormat('en-ZA', { style: 'currency', currency: currency || 'ZAR' }).format(amount);
    } catch (e) {
      return amount.toFixed(2);
    }
  }

  function parseProductIds(value) {
    if (!value) return [];
    return value
      .split(',')
      .map(function (id) {
        return parseInt(id, 10);
      })
      .filter(function (id) {
        return !isNaN(id);
      });
  }

  function matchesRewardProduct(item, root) {
    var rewardProductId = parseInt(root.dataset.rewardProductId, 10);
    var rewardVariantId = parseInt(root.dataset.rewardVariantId, 10);
    if (rewardVariantId && item.variant_id === rewardVariantId) return true;
    if (rewardProductId && item.product_id === rewardProductId) return true;
    return false;
  }

  function getLineItemPropertyKey(root) {
    return root.dataset.lineItemPropertyKey || 'Free gift';
  }

  function getGiftPropertyValue(root) {
    return root.dataset.giftPropertyValue || 'true';
  }

  function getPropertyValue(item, propertyKey) {
    if (!item || !propertyKey) return '';

    if (item.properties) {
      var value = item.properties[propertyKey];
      if (value != null && value !== '') return String(value);
    }

    if (Array.isArray(item.properties)) {
      for (var i = 0; i < item.properties.length; i++) {
        var entry = item.properties[i];
        if (!entry) continue;
        var key = entry.key || entry.first || entry.name;
        var entryValue = entry.value || entry.last;
        if (key === propertyKey && entryValue != null && entryValue !== '') {
          return String(entryValue);
        }
      }
    }

    return '';
  }

  function hasAnyGiftMarker(item, root) {
    if (hasGiftProperty(item, root)) return true;
    if (getPropertyValue(item, 'True') !== '') return true;
    if (getPropertyValue(item, '_biomax_free_gift') !== '') return true;
    if (getPropertyValue(item, '_free_gift') !== '') return true;
    return false;
  }

  function isFreeGiftLineItem(item, root) {
    if (!matchesRewardProduct(item, root)) return false;

    if (hasAnyGiftMarker(item, root)) return true;

    var lineTotal = Number(item.final_line_price != null ? item.final_line_price : item.line_price || 0);
    return lineTotal === 0;
  }

  function isPaidRewardLineItem(item, root) {
    return matchesRewardProduct(item, root) && !isFreeGiftLineItem(item, root);
  }

  function getSpendTotal(cart, root) {
    var scope = root.dataset.spendScope || 'cart';
    var requirementProductId = parseInt(root.dataset.requirementProductId, 10);
    var requirementProductIds = parseProductIds(root.dataset.requirementProductIds || '');
    if (requirementProductId && requirementProductIds.indexOf(requirementProductId) === -1) {
      requirementProductIds.push(requirementProductId);
    }
    var collectionProductIds = parseProductIds(root.dataset.collectionProductIds);
    var total = 0;

    (cart.items || []).forEach(function (item) {
      if (isFreeGiftLineItem(item, root)) return;
      if (matchesRewardProduct(item, root)) return;

      var lineTotal = Number(item.final_line_price || item.line_price || 0);
      if (scope === 'cart') {
        total += lineTotal;
        return;
      }
      if (scope === 'product' && requirementProductIds.indexOf(item.product_id) !== -1) {
        total += lineTotal;
        return;
      }
      if (scope === 'collection' && collectionProductIds.indexOf(item.product_id) !== -1) {
        total += lineTotal;
      }
    });

    return total;
  }

  function getQuantityTotal(cart, root) {
    var productId = parseInt(root.dataset.requirementProductId, 10);
    var productIdsCsv = root.dataset.requirementProductIds || '';
    var ids = parseProductIds(productIdsCsv);
    if (productId && ids.indexOf(productId) === -1) {
      ids.push(productId);
    }

    var total = 0;
    (cart.items || []).forEach(function (item) {
      if (isFreeGiftLineItem(item, root)) return;
      if (ids.indexOf(item.product_id) !== -1) {
        total += Number(item.quantity || 0);
      }
    });
    return total;
  }

  function isDealQualified(root, cart) {
    var type = root.dataset.requirementType;

    if (type === 'quantity') {
      var required = parseInt(root.dataset.requiredQuantity, 10) || 1;
      var current = getQuantityTotal(cart, root);
      return Math.max(0, required - current) === 0;
    }

    if (type === 'spend') {
      var thresholdCents = parseFloat(root.dataset.spendThresholdCents, 10) || 0;
      var currentSpend = getSpendTotal(cart, root);
      return Math.max(0, thresholdCents - currentSpend) === 0;
    }

    return false;
  }

  function getTaggedFreeGiftItems(cart, root) {
    return (cart.items || []).filter(function (item) {
      return matchesRewardProduct(item, root) && hasGiftProperty(item, root);
    });
  }

  function hasGiftProperty(item, root) {
    var propertyKey = getLineItemPropertyKey(root);
    return getPropertyValue(item, propertyKey) === getGiftPropertyValue(root);
  }

  function getFreeGiftItems(cart, root) {
    return (cart.items || []).filter(function (item) {
      return isFreeGiftLineItem(item, root);
    });
  }

  function dealNeedsSync(root, cart) {
    var qualified = isDealQualified(root, cart);
    var giftLines = getFreeGiftItems(cart, root);
    var autoAdd = root.dataset.autoAddReward !== 'false';

    if (qualified && giftLines.length === 0 && autoAdd) return true;
    if (!qualified && giftLines.length > 0) return true;
    return false;
  }

  function removeFreeGiftLines(cart, root, tasks) {
    var seenKeys = {};

    getFreeGiftItems(cart, root).forEach(function (item) {
      if (!item || !item.key || seenKeys[item.key]) return;
      seenKeys[item.key] = true;
      tasks.push(function () {
        return changeRewardItem(item.key, 0);
      });
    });
  }

  function postJson(url, payload) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(payload),
    }).then(function (response) {
      if (!response.ok) {
        return response.json().then(function (data) {
          throw new Error((data && data.description) || 'Cart request failed');
        });
      }
      return response.json();
    });
  }

  function addRewardItem(variantId, propertyKey, propertyValue) {
    var properties = {};
    properties[propertyKey] = propertyValue;

    return postJson('/cart/add.js', {
      items: [{ id: variantId, quantity: 1, properties: properties }],
    });
  }

  function changeRewardItem(lineKey, quantity, properties) {
    var payload = { id: lineKey, quantity: quantity };
    if (properties) payload.properties = properties;

    return postJson('/cart/change.js', payload);
  }

  function buildGiftProperties(item, root) {
    var propertyKey = getLineItemPropertyKey(root);
    var properties = Object.assign({}, item.properties || {});

    ['True', '_biomax_free_gift'].forEach(function (legacyKey) {
      if (legacyKey !== propertyKey) {
        delete properties[legacyKey];
      }
    });

    properties[propertyKey] = getGiftPropertyValue(root);
    return properties;
  }

  function clearAllDealProperties(item, root) {
    var properties = Object.assign({}, item.properties || {});
    var propertyKey = getLineItemPropertyKey(root);

    [propertyKey, 'True', '_biomax_free_gift'].forEach(function (key) {
      delete properties[key];
    });

    return changeRewardItem(item.key, item.quantity, properties);
  }

  function giftPropertiesNeedUpdate(item, root) {
    if (!hasGiftProperty(item, root)) return true;

    var expected = buildGiftProperties(item, root);
    var propertyKey = getLineItemPropertyKey(root);

    return (
      getPropertyValue(item, propertyKey) !== getGiftPropertyValue(root) ||
      getPropertyValue(item, 'True') !== '' ||
      getPropertyValue(item, '_biomax_free_gift') !== ''
    );
  }

  function isPureCartPage() {
    var mainCartItems = document.getElementById('main-cart-items');
    return !!(mainCartItems && mainCartItems.querySelector('.pure-cart-grid'));
  }

  function isPixelCartPage() {
    var mainCartItems = document.getElementById('main-cart-items');
    var mainCartFooter = document.getElementById('main-cart-footer');
    return (
      mainCartItems &&
      mainCartFooter &&
      mainCartItems.dataset.id &&
      mainCartItems.dataset.id === mainCartFooter.dataset.id
    );
  }

  function parseSectionHtml(html) {
    return new DOMParser().parseFromString(
      String(html || '').replaceAll('cart-coupon-discount', 'div'),
      'text/html'
    );
  }

  function refreshPureCartSections() {
    var mainCartItems = document.getElementById('main-cart-items');
    var cartRoot = document.querySelector('[data-cart]');
    if (!mainCartItems || !mainCartItems.dataset.id || !cartRoot) {
      return Promise.resolve();
    }

    return fetch('/cart?section_id=' + encodeURIComponent(mainCartItems.dataset.id), {
      credentials: 'same-origin',
      cache: 'no-store',
    })
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var doc = parseSectionHtml(html);
        var nextCartList = doc.querySelector('[data-cart-content] .cart-list');
        var currentCartList = cartRoot.querySelector('[data-cart-content] .cart-list');

        if (nextCartList && currentCartList) {
          currentCartList.innerHTML = nextCartList.innerHTML;
        }

        var nextGifts = doc.querySelector('.pure-cart-gifts');
        var currentGifts = cartRoot.querySelector('.pure-cart-gifts');
        if (nextGifts && currentGifts) {
          currentGifts.innerHTML = nextGifts.innerHTML;
        }

        [
          '.cart-total-subtotal',
          '.cart-total-grandtotal',
          '.cart-total-savings',
        ].forEach(function (selector) {
          var nextTotal = doc.querySelector('[data-cart-total] ' + selector);
          var currentTotal = cartRoot.querySelector('[data-cart-total] ' + selector);
          if (nextTotal && currentTotal) {
            currentTotal.innerHTML = nextTotal.innerHTML;
          }
        });

        var nextCount = doc.querySelector('[data-cart-count]');
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          if (nextCount) {
            el.textContent = nextCount.textContent;
          }
        });

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-gift-deal-sync' });
        }

        document.dispatchEvent(new CustomEvent('cart:updated'));
      })
      .catch(function () {});
  }

  function getSectionsToRender() {
    var sections = [];
    var mainCartItems = document.getElementById('main-cart-items');
    var pixelCart = isPixelCartPage();

    if (mainCartItems && mainCartItems.dataset.id) {
      sections.push({
        id: 'main-cart-items',
        section: mainCartItems.dataset.id,
        selector: '.js-contents',
      });
    }

    var mainCartFooter = document.getElementById('main-cart-footer');
    if (mainCartFooter && mainCartFooter.dataset.id) {
      sections.push({
        id: 'main-cart-footer',
        section: mainCartFooter.dataset.id,
        selector: pixelCart ? '.pixel-cart-footer__contents' : '.cart__footer',
      });
    }

    return sections;
  }

  function getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  function refreshCartSections() {
    if (isPureCartPage()) {
      return refreshPureCartSections();
    }

    var sections = getSectionsToRender();
    if (!sections.length) return Promise.resolve();

    var sectionIds = sections.map(function (section) {
      return section.section;
    });

    return fetch(window.location.pathname + '?sections=' + sectionIds.join(','), {
      credentials: 'same-origin',
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (sectionHtml) {
        sections.forEach(function (section) {
          var target = document.getElementById(section.id);
          if (!target) return;

          var html = sectionHtml[section.section];
          if (!html) return;

          var replacement =
            target.querySelector(section.selector) || target;
          var nextHtml = getSectionInnerHTML(html, section.selector);
          if (nextHtml != null) {
            replacement.innerHTML = nextHtml;
          }
        });

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-gift-deal-sync' });
        }

        document.dispatchEvent(new CustomEvent('cart:updated'));
      })
      .catch(function () {});
  }

  function syncDealRewards(cart) {
    var deals = document.querySelectorAll('[data-cart-gift-deal]');
    if (!deals.length) return Promise.resolve(false);

    var tasks = [];

    deals.forEach(function (root) {
      var propertyKey = getLineItemPropertyKey(root);
      var variantId = parseInt(root.dataset.rewardVariantId, 10);
      if (!variantId) return;

      var autoAdd = root.dataset.autoAddReward !== 'false';
      var giftPropertyValue = getGiftPropertyValue(root);
      var qualified = isDealQualified(root, cart);
      var taggedGiftItems = getTaggedFreeGiftItems(cart, root);
      var freeGiftItems = getFreeGiftItems(cart, root);

      (cart.items || []).forEach(function (item) {
        if (!isPaidRewardLineItem(item, root)) return;
        if (
          getPropertyValue(item, propertyKey) !== '' ||
          getPropertyValue(item, 'True') !== '' ||
          getPropertyValue(item, '_biomax_free_gift') !== ''
        ) {
          tasks.push(function () {
            return clearAllDealProperties(item, root);
          });
        }
      });

      if (qualified) {
        var primaryGift = taggedGiftItems[0] || freeGiftItems[0];

        if (primaryGift) {
          if (giftPropertiesNeedUpdate(primaryGift, root) || primaryGift.quantity > 1) {
            tasks.push(function () {
              return changeRewardItem(
                primaryGift.key,
                1,
                buildGiftProperties(primaryGift, root)
              );
            });
          }

          freeGiftItems.forEach(function (item) {
            if (item.key === primaryGift.key) return;
            tasks.push(function () {
              return changeRewardItem(item.key, 0);
            });
          });
        } else if (autoAdd) {
          tasks.push(function () {
            return addRewardItem(variantId, propertyKey, giftPropertyValue);
          });
        }

        return;
      }

      removeFreeGiftLines(cart, root, tasks);
    });

    if (!tasks.length) return Promise.resolve(false);

    window.__cartGiftDealSyncing = true;

    return tasks
      .reduce(function (chain, task) {
        return chain.then(task);
      }, Promise.resolve())
      .then(function () {
        return true;
      })
      .catch(function () {
        return false;
      })
      .finally(function () {
        window.__cartGiftDealSyncing = false;
      });
  }

  function syncDealRewardsWithRetry(cart, attempt) {
    return syncDealRewards(cart).then(function (changed) {
      if (changed || attempt >= 1) return changed;

      return new Promise(function (resolve) {
        setTimeout(function () {
          fetch('/cart.js', { credentials: 'same-origin' })
            .then(function (response) {
              return response.json();
            })
            .then(function (freshCart) {
              syncDealRewards(freshCart).then(resolve);
            })
            .catch(function () {
              resolve(false);
            });
        }, 600);
      });
    });
  }

  function updateDeal(root, cart) {
    var type = root.dataset.requirementType;
    var fill = root.querySelector('[data-cart-gift-deal-fill]');
    var message = root.querySelector('[data-cart-gift-deal-message]');
    var track = root.querySelector('.free-shipping-progress__track');
    var claimBtn = root.querySelector('[data-cart-gift-deal-claim]');
    if (!fill || !message) return;

    var currency = root.dataset.currency || 'ZAR';
    var unlockedMessage = root.dataset.unlockedMessage || '';
    var isComplete = isDealQualified(root, cart);
    var progress = 0;
    var ariaNow = 0;
    var ariaMax = 100;

    if (type === 'quantity') {
      var required = parseInt(root.dataset.requiredQuantity, 10) || 1;
      var current = getQuantityTotal(cart, root);
      var remaining = Math.max(0, required - current);
      progress = Math.max(0, Math.min(100, (current / required) * 100));
      ariaNow = Math.min(current, required);
      ariaMax = required;

      if (isComplete) {
        message.textContent = unlockedMessage;
      } else {
        var quantityTemplate = root.dataset.quantityAwayMessage || '[[count]] more to qualify';
        message.textContent = quantityTemplate.replace(/\[\[count\]\]/g, String(remaining));
      }
    } else if (type === 'spend') {
      var thresholdCents = parseFloat(root.dataset.spendThresholdCents, 10) || 0;
      var currentSpend = getSpendTotal(cart, root);
      var remainingCents = Math.max(0, thresholdCents - currentSpend);
      progress = thresholdCents > 0 ? Math.max(0, Math.min(100, (currentSpend / thresholdCents) * 100)) : 0;
      ariaNow = Math.min(currentSpend / 100, thresholdCents / 100);
      ariaMax = thresholdCents / 100;

      if (isComplete) {
        message.textContent = unlockedMessage;
      } else {
        var prefix = root.dataset.spendAwayPrefix || '';
        var suffix = root.dataset.spendAwaySuffix || '';
        message.textContent = prefix + ' ' + formatMoney(remainingCents, currency) + ' ' + suffix;
      }
    }

    fill.style.width = (isComplete ? 100 : progress) + '%';
    fill.classList.toggle('is-complete', isComplete);
    root.classList.toggle('is-qualified', isComplete);

    if (track) {
      track.setAttribute('aria-valuenow', ariaNow);
      track.setAttribute('aria-valuemax', ariaMax);
    }

    if (claimBtn) {
      var inCart = getFreeGiftItems(cart, root).length > 0;
      var showClaim = root.dataset.showClaimButton === 'true' && isComplete;

      claimBtn.classList.toggle('is-hidden', !showClaim);
      claimBtn.disabled = inCart;
      claimBtn.textContent = inCart ? claimBtn.dataset.inCartLabel || 'In cart' : claimBtn.dataset.claimLabel || 'Add free gift';
      claimBtn.setAttribute('data-is-in-cart', inCart ? 'true' : 'false');
    }
  }

  function updateAll(cart) {
    document.querySelectorAll('[data-cart-gift-deal]').forEach(function (root) {
      updateDeal(root, cart);
    });
  }

  function fetchCartSyncAndUpdate() {
    if (window.__cartGiftDealSyncing) {
      scheduleUpdate(200);
      return;
    }

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        updateAll(cart);
        return syncDealRewardsWithRetry(cart, 0).then(function (changed) {
          if (changed) {
            return refreshCartSections().then(function () {
              return fetch('/cart.js', { credentials: 'same-origin' }).then(function (response) {
                return response.json();
              });
            });
          }
          return cart;
        });
      })
      .then(function (cart) {
        bindClaimButtons();
        updateAll(cart);
      })
      .catch(function () {});
  }

  function scheduleUpdate(delay, optimisticCart) {
    clearTimeout(window.__cartGiftDealSyncTimer);
    if (optimisticCart && optimisticCart.items) {
      updateAll(optimisticCart);
    }
    window.__cartGiftDealSyncTimer = setTimeout(fetchCartSyncAndUpdate, delay || 150);
  }

  function bindCheckoutSync() {
    var cartForm = document.getElementById('cart');
    if (!cartForm || cartForm.dataset.giftDealCheckoutBound === 'true') return;
    if (!document.querySelector('[data-cart-gift-deal]')) return;

    cartForm.dataset.giftDealCheckoutBound = 'true';

    cartForm.addEventListener('submit', function (event) {
      var submitter = event.submitter;
      var isCheckout =
        submitter &&
        (submitter.name === 'checkout' || submitter.id === 'checkout' || submitter.getAttribute('formaction'));

      if (!isCheckout || cartForm.dataset.giftDealAllowCheckout === 'true') {
        cartForm.dataset.giftDealAllowCheckout = 'false';
        return;
      }

      event.preventDefault();

      if (window.__cartGiftDealSyncing) {
        scheduleUpdate(200);
        return;
      }

      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          return syncDealRewardsWithRetry(cart, 0);
        })
        .then(function () {
          cartForm.dataset.giftDealAllowCheckout = 'true';
          if (submitter && typeof cartForm.requestSubmit === 'function') {
            cartForm.requestSubmit(submitter);
          } else {
            cartForm.submit();
          }
        })
        .catch(function () {
          cartForm.dataset.giftDealAllowCheckout = 'true';
          if (submitter && typeof cartForm.requestSubmit === 'function') {
            cartForm.requestSubmit(submitter);
          } else {
            cartForm.submit();
          }
        });
    });
  }

  function bindClaimButtons() {
    document.querySelectorAll('[data-cart-gift-deal-claim]').forEach(function (btn) {
      if (btn.dataset.bound === 'true') return;
      btn.dataset.bound = 'true';

      btn.addEventListener('click', function () {
        if (btn.getAttribute('data-is-in-cart') === 'true' || btn.disabled) return;

        var dealRoot = btn.closest('[data-cart-gift-deal]');
        var variantId = parseInt(btn.dataset.variantId, 10);
        var propertyKey = dealRoot ? getLineItemPropertyKey(dealRoot) : 'Free gift';
        if (!variantId) return;

        btn.disabled = true;
        btn.textContent = btn.dataset.addingLabel || 'Adding...';

        var payload = { items: [{ id: variantId, quantity: 1 }] };
        if (propertyKey) {
          var properties = {};
          properties[propertyKey] = getGiftPropertyValue(dealRoot);
          payload.items[0].properties = properties;
        }

        postJson('/cart/add.js', payload)
          .then(function () {
            return refreshCartSections();
          })
          .then(function () {
            scheduleUpdate(100);
          })
          .catch(function () {
            btn.disabled = false;
            btn.textContent = btn.dataset.claimLabel || 'Add free gift';
          });
      });
    });
  }

  function bindListeners() {
    if (window.__cartGiftDealBound) return;
    window.__cartGiftDealBound = true;

    document.body.addEventListener('change', function (event) {
      if (
        event.target &&
        (event.target.closest('.quantity__input') || event.target.closest('.cart-item-qty-input'))
      ) {
        scheduleUpdate(900);
      }
    });

    document.body.addEventListener('click', function (event) {
      if (
        event.target &&
        (event.target.closest('.quantity__button') ||
          event.target.closest('cart-remove-button') ||
          event.target.closest('[data-cart-remove]') ||
          event.target.closest('[data-minus-quantity-cart]') ||
          event.target.closest('[data-plus-quantity-cart]'))
      ) {
        scheduleUpdate(900);
      }
    });

    document.addEventListener('cart:updated', function () {
      scheduleUpdate(150);
    });

    document.addEventListener('cart-update', function (event) {
      if (window.__cartGiftDealSyncing) return;
      scheduleUpdate(250, event && event.detail);
    });

    if (isPureCartPage() && !window.__cartGiftDealPoll) {
      window.__cartGiftDealPoll = setInterval(function () {
        if (window.__cartGiftDealSyncing) return;
        fetch('/cart.js', { credentials: 'same-origin' })
          .then(function (response) {
            return response.json();
          })
          .then(function (cart) {
            var deals = document.querySelectorAll('[data-cart-gift-deal]');
            var needsSync = false;
            deals.forEach(function (root) {
              if (dealNeedsSync(root, cart)) {
                needsSync = true;
              }
            });
            if (needsSync) {
              scheduleUpdate(100, cart);
            } else {
              updateAll(cart);
            }
          })
          .catch(function () {});
      }, 1500);
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event && event.source === 'cart-gift-deal-sync') return;
        scheduleUpdate(250, event && event.cartData);
      });
    }
  }

  function init() {
    bindListeners();
    bindClaimButtons();
    bindCheckoutSync();
    fetchCartSyncAndUpdate();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
